import { Injectable, TemplateRef } from '@angular/core';
export class NgxBootstrapProductTourStepService {
public template: TemplateRef<{ content: string }>;
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgxBootstrapProductTourStepService_tsickle_Closure_declarations() {
/** @type {?} */
NgxBootstrapProductTourStepService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxBootstrapProductTourStepService.ctorParameters;
/** @type {?} */
NgxBootstrapProductTourStepService.prototype.template;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
